import React from 'react';

function Message({ text }) {
  return <div className="Message alert alert-info">{text}</div>;
}

export default Message;
